import { DefaultOptionType } from 'components/CIMSSelect/types'

export type PermissionConditionKey =
  | 'fieldIds'
  | 'statusIds'
  | 'approvalStatusId'

export type PermissionActionMetadata = {
  label: string
  description: string
  conditionKeys: readonly PermissionConditionKey[]
}

export const permissionActionMetadata = {
  'workflow_record.create': {
    label: 'Create Record',
    description: 'Create workflow records',
    conditionKeys: [],
  },
  'workflow_record.remove_restore': {
    label: 'Remove / Restore Records',
    description: 'Remove and restore workflow records',
    conditionKeys: [],
  },
  'workflow_record.revert': {
    label: 'Revert Records',
    description: 'Revert closed workflow records to selected statuses',
    conditionKeys: ['statusIds'],
  },
  'field.edit': {
    label: 'Edit Fields',
    description: 'Edit selected fields while records are in selected statuses',
    conditionKeys: ['fieldIds', 'statusIds'],
  },
  'approvals_status.advance': {
    label: 'Advance Approval Status',
    description: 'Advance a selected approval status to selected statuses',
    conditionKeys: ['approvalStatusId', 'statusIds'],
  },
  'approvals_status.fast_track': {
    label: 'Fast Track Approval Status',
    description: 'Fast track a selected approval status to selected statuses',
    conditionKeys: ['approvalStatusId', 'statusIds'],
  },
  'sharepoint-plugin.upload_remove': {
    label: 'Upload / Remove SharePoint Files',
    description: 'Upload and remove SharePoint files in selected statuses',
    conditionKeys: ['statusIds'],
  },
  'sharepoint-plugin.create_packet': {
    label: 'Create SharePoint Packet',
    description: 'Manually create SharePoint packets',
    conditionKeys: [],
  },
  'comment.create': {
    label: 'Create Comment',
    description: 'Create comments on workflow records',
    conditionKeys: [],
  },
} as const

export type WorkflowPermissionAction = keyof typeof permissionActionMetadata

export const permissionActionOptions: DefaultOptionType[] = Object.entries(
  permissionActionMetadata
).map(([value, { label, description }]) => ({
  value,
  label: `${label} - ${description}`,
}))

export function isWorkflowPermissionAction(
  action: string | undefined
): action is WorkflowPermissionAction {
  return !!action && action in permissionActionMetadata
}

export function getPermissionActionMetadata(
  action: string
): PermissionActionMetadata {
  if (isWorkflowPermissionAction(action))
    return permissionActionMetadata[action]
  return {
    label: action,
    description: 'Unknown permission action.',
    conditionKeys: [],
  }
}
